<script setup>
  const { girls } = defineProps(['girls']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap wide>
    <BigTitle h1><slot /></BigTitle>
    <Foreground>
      <ShowAnimation>
        <Card class="container">
          <h2>Glory Girls</h2>
          <ul>
            <li v-for="girl in girls">
              <ClickableCard :to="girl.instagram" :class="{ disabled: !girl.instagram }">
                <img :src="girl.image.url" :alt="girl.name" />
                <IconInstagram v-if="girl.instagram" />
                <!-- <Social v-if="girl.instagram" type="instagram" :url="girl.instagram" /> -->
                <h3>
                  <span>{{ girl.name }}</span>
                </h3>
              </ClickableCard>
            </li>
          </ul>
        </Card>
      </ShowAnimation>
    </Foreground>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    @include top-padding;
    padding-bottom: px(100);

    .foreground {
      @include grid;

      .container {
        background-color: $black;

        display: flex;
        flex-direction: column;
        align-items: stretch;

        padding: px(88) px(35) px(64);

        @include break-min-small {
          @include column(2, 11);
        }
      }
    }

    h2 {
      font-size: px(48);
      text-align: center;

      margin-bottom: px(42);
    }

    ul {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    li {
      border-right: px(1) solid $black-5;
      border-bottom: px(1) solid $black-5;

      @include break-min-small {
        // left items
        &:nth-child(4n + 1) {
          border-left: px(1) solid $black-5;
        }

        // top items
        &:not(:nth-child(n + 5)) {
          border-top: px(1) solid $black-5;
        }
      }

      .card {
        position: relative;
        display: flex;
        flex-direction: column;

        &.disabled {
          pointer-events: none;
        }
      }

      img {
        width: 100%;
        height: 20vw;

        object-fit: cover;
      }

      svg {
        position: absolute;

        top: px(24);
        right: px(24);

        width: px(24);
        height: px(24);
      }

      h3 {
        height: px(64);
        font-size: px(28);

        display: flex;
        align-items: center;
        justify-content: center;

        border-top: px(1) solid $black-5;

        span {
          margin-top: 0.1em;
        }
      }
    }

    @include break-large {
      li {
        h3 {
          font-size: px(24);
        }
      }
    }

    @include break-medium {
      li {
        h3 {
          font-size: px(20);
        }
      }
    }

    @include break-small {
      .foreground {
        .container {
          padding: px(56) px(20) px(64);
        }
      }

      h2 {
        font-size: px(32);
        margin-bottom: px(24);
      }

      ul {
        grid-template-columns: 1fr 1fr;
      }

      li {
        @include break-min-phone {
          // left items
          &:nth-child(2n + 1) {
            border-left: px(1) solid $black-5;
          }

          // top items
          &:not(:nth-child(n + 3)) {
            border-top: px(1) solid $black-5;
          }
        }

        img {
          height: 46vw;
        }

        h3 {
          font-size: px(24);
        }
      }
    }

    @include break-phone {
      .foreground {
        .container {
          padding: px(52) 0 px(64);
        }
      }

      h2 {
        margin-bottom: px(18);
      }

      li {
        border: px(1) solid $black-5;

        &:nth-child(odd) {
          border-left: 0;
          border-right: 0;
        }

        &:nth-child(even) {
          border-right: 0;
        }

        &:nth-child(n + 3) {
          border-top: 0;
        }

        img {
          height: 50vw;
        }

        svg {
          width: px(16);
          height: px(16);

          top: px(13);
          right: px(13);
        }

        h3 {
          font-size: 5.5vw;
        }
      }
    }
  }
</style>
